module.exports = '4.6.0';



// WEBPACK FOOTER //
// ./src/version.js